/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ZuperPopupConfig } from './zuper-popup.interface';

@Injectable({
  providedIn: 'root'
})
export class ZuperPopupService {
  openPopupSubject = new Subject<any>();
  closePopupSubject = new Subject<any>();
  afterClosedPopupSubject = new Subject<any>();

  constructor() {
    //Zuper Wrapper Service constructor
  }

  openZuperPopup(config: ZuperPopupConfig): void {
    this.openPopupSubject.next(config);
  }

  onOpenZuperPopup(): Observable<any> {
    return this.openPopupSubject.asObservable();
  }

  onCloseZuperPopup(): Observable<any> {
    return this.closePopupSubject.asObservable();
  }

  afterClosedZuperPopup(): Observable<any> {
    return this.afterClosedPopupSubject.asObservable();
  }
}
